import { Component } from '@angular/core';
import { ListProvider } from '../../providers/list/list';
import { NavParams, NavController, Events } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { AppState } from '../../config/state';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
/**
 * Generated class for the CoMyEventListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-list',
  templateUrl: 'co-list.html'
})
export class CoListComponent {

  list: any;
  clientKeyword: string;
  itemsToRemove: Array<any> = [];
  listType: string;
  density: number = 1;
  editMode: boolean = true;

  constructor(private listProvider: ListProvider, private navParams: NavParams, private config: ConfigProvider, private navCtrl: NavController, private events: Events, private state : AppState, private toast : ToastAlertsProvider) {
    this.clientKeyword = this.navParams.data.clientKeyword;
    this.listType = this.navParams.data.listType;
    this.getList();
  }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
  }
  getList() {
    let self = this;
    this.listProvider.getList(this.listType).then((res) => {
      self.list = res;
      self.events.subscribe('updateAllEvents', () => {
        self.listProvider.getList(this.listType).then((res) => {
          self.list = res;
        });
      });
      let i = 0;
      self.list.forEach(element => {
        if (element.value.eventId === undefined) {
          self.list.splice(i, 1);
        }
        element.value.interested = true;
        i++;
      });
      // console.log(self.list);
    });
  }

  goToEventDetails(eventId, searchTypes) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId, searchTags: searchTypes });
    });
  }

  updateList(event) {
    let inList: boolean = false;
    let i = 0;
    this.itemsToRemove.forEach(element => {
      if (element === event) {
        inList = true;
        this.itemsToRemove.splice(i, 1);
      }
      i++;
    });

    if (inList) {
      return;
    } else {
      this.itemsToRemove.push(event);
    }
  }

  removeFromList() {
    if (this.itemsToRemove.length === 0) {
      return;
    }

    this.listProvider.removeFromList(this.itemsToRemove, this.listType).then((res) => {
      if (res.success) {
        this.itemsToRemove = [];
        this.getList();
        this.events.publish('updateAllEvents');
        this.toast.triggerToast('Items removed from cart!', '');
        if (this.density === 2) {
          this.editMode = false;
        }
      } else {
        this.toast.triggerToast('Failed to remove items from list','');
      }
    });
  }

  switchDensity(density) {
    if (this.density === density) {
      return;
    }

    if (density === 2) {
      this.editMode = false;
    } else {
      this.editMode = true;
    }
    this.density = density;
    this.itemsToRemove = [];
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    this.itemsToRemove = [];
  }
}


// WEBPACK FOOTER //
// ./src/components/co-list/co-list.ts